module.exports = __webpack_public_path__ + "img/icon-log.3e2a4a8a.svg";